export const DealTypesNames = {
    'Spot': 1,
    'DrawDown': 2,
    'Forward': 4,
    'Option': 5,
    'Swap': 6,
    'Deal Transfer': 7,
    'Loss Transaction': 8
}